<template>
    <div v-if="model.app.id && model.currentUser" class="full-height-container ms-4">
        <div class="mt-4">
            <h3>Current Integrations</h3>

            <div v-if="model.app.integrations.length > 0">
                <div v-for="integration in model.app.integrations" class="card p-4" style="width: 18rem;">

                    <netlify v-if="integration.name === 'Netlify'" :integration="integration"></netlify>

                    <div v-else>
                        {{integration.name}}
                    </div>

                </div>

            </div>

            <div v-else>
                You do not have any integrations yet.
            </div>
        </div>

        <hr>

        <div class="mt-4">
            <h3>Available Integrations</h3>

<!--            <div v-if="!hasIntegration('Slack')" class="card p-3 my-1" style="width: 18rem;">-->
<!--                <h4>Slack</h4>-->
<!--                <a :href="slackUrl"><img alt="Add to Slack" height="40" width="139"-->
<!--                                         src="https://platform.slack-edge.com/img/add_to_slack.png"-->
<!--                                         srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"></a>-->
<!--            </div>-->

            <div v-if="!hasIntegration('Netlify')" class="card p-3 my-1" style="width: 18rem;">
                <h4>Netlify</h4>
                <a :href="netlifyUrl">
                    <netlify></netlify>
                </a>
            </div>

        </div>

        <integrations-modal key="integrationsModal" v-if="showIntegrationsModal" :integration="currentIntegration"
                    @noEvent="showIntegrationsModal = false"></integrations-modal>

    </div>
</template>

<script>
    import IntegrationsModal from "./integrations/IntegrationModal.vue";
    import AppService from "./services/AppService";
    import Netlify from "./integrations/Netlify.vue";
    import NewNetlifySiteModal from "./integrations/NewNetlifySiteModal.vue";
    export default {
        name: 'Integrations',
        components: {NewNetlifySiteModal, Netlify, IntegrationsModal},
        props: ['prop1', 'prop2'],
        data() {
            return {
                model: webase.model,
                showIntegrationsModal: false,
                currentIntegration: {
                    id: null,
                    name: '',
                    app_id: null,
                    metadata: {
                        api_key: ''
                    }
                }
            }
        },
        computed: {
            slackUrl() {
                let url = 'https://slack.com/oauth/v2/authorize?client_id=13068172832.919176894997&scope=incoming-webhook,channels:read'
                return url + '&app_id=' + this.model.app.id
            },

            netlifyUrl() {
                let url = 'https://app.netlify.com/authorize?client_id=' + this.netlifyClientId + '&response_type=code'
                return url + '&redirect_uri=' + this.netlifyRedirectUri + '&app_id=' + this.model.app.id
            },

            isAdmin() {
                return this.model.currentUser && webase.utils.user.isAdmin()
            },

            netlifyRedirectUri() {
                if(process.env.NODE_ENV === 'development') {
                    return 'http://localhost:3000/auth/callback/netlify'
                }

                return 'https://www.webase.com/auth/callback/netlify'
            },

            netlifyClientId() {
                if(process.env.NODE_ENV === 'development') {
                    return 'DXXFjrswBWaAm8UsXptl3eLR1e7j-DT68yWW9ccdYA8'
                }

                return '129b258d256c94900cf106c9c2ddc772f8ddc0032962c194af2bb32208427947'
            }
        },
        mounted() {

            if(!this.model.app.id) {
                let appId = this.$route.params.id
                let appService = new AppService()

                appService.initApp(appId).then((response) => {
                    console.log('App initialized')
                }).catch((message) => {
                    console.log('error loading app')
                    console.log(message)
                })
            }
        },
        methods: {
            onCreateIntegrationClick(integrationName) {
                this.currentIntegration = {
                    id: null,
                    name: integrationName,
                    app_id: this.model.app.id,
                    metadata: {
                        api_key: ''
                    }
                }

                this.showIntegrationsModal = true
            },
            hasIntegration(name) {
                return this.model.app.integrations.filter(integrataion => (integrataion.name === name)).length > 0
            }
        }
    }
</script>

<style>

</style>
